import { Icon } from '@types';

export const Account = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 96 96"
			xmlSpace="preserve"
			onClick={handleClick}
			className={customStyles}
		>
			<style>
				{
					'\n    .st0{fill:#fff}.st1{fill:none;stroke:#231f20;stroke-width:3;stroke-miterlimit:10}\n  '
				}
			</style>
			<switch>
				<foreignObject
					requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"
					x={0}
					y={0}
					width={1}
					height={1}
				/>
				<g>
					<path d="M48 9C26.5 9 9 26.5 9 48s17.5 39 39 39 39-17.5 39-39S69.5 9 48 9zM29.2 77.5c.3-10.4 8.9-19.4 18.8-19.4s18.5 9 18.8 19.4C61.4 81 54.9 83 48 83s-13.4-2-18.8-5.5zm10-34.3c0-4.8 3.9-8.8 8.8-8.8s8.8 3.9 8.8 8.8-4 8.8-8.8 8.8-8.8-3.9-8.8-8.8zm31.4 31.5c-1.3-9.6-8.3-17.6-17.2-19.9 4.4-2 7.4-6.4 7.4-11.6 0-7-5.7-12.8-12.8-12.8s-12.8 5.7-12.8 12.8c0 5.1 3 9.5 7.4 11.6-8.9 2.4-15.9 10.3-17.2 19.9C17.8 68.3 13 58.7 13 48c0-19.3 15.7-35 35-35s35 15.7 35 35c0 10.7-4.8 20.3-12.4 26.7z" />
				</g>
			</switch>
		</svg>
	);
};
